export const globalConstants = {
    START_LOADING: 'START_LOADING',
    STOP_LOADING: 'STOP_LOADING',

    LOADCOURTS_REQUEST: 'LOADCOURTS_REQUEST',
    LOADCOURTS_SUCCESS: 'LOADCOURTS_SUCCESS',
    LOADCOURTS_FAILURE: 'LOADCOURTS_FAILURE',

    LOADCONFIG_REQUEST: 'LOADCONFIG_REQUEST',
    LOADCONFIG_SUCCESS: 'LOADCONFIG_SUCCESS',
    LOADCONFIG_FAILURE: 'LOADCONFIG_FAILURE',
};
